import { css } from '@inter-ikea-kompis/web-component';
export default class FinancialServicesCardStyle {
    /**
     * Returns styles.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        return css `
			/* Override font-family since the provided font-family 'Noto IKEA' from the API is not available. */
			.monthlypay_fragment,
			div {
				font-family: ${this.getFontFamily(options.theme)} !important;
			}

			/* Remove header margin and padding to look similar to Ingka's version. */
			h1,
			h2,
			h3,
			h4,
			h5,
			h6 {
				margin: 0;
				padding: 0;
			}
		`;
    }
    /**
     * Get the font-family from the theme.
     *
     * @param theme The theme.
     * @returns The font family.
     */
    static getFontFamily(theme) {
        return [theme.fontFace.family, ...theme.fontFace.fallbacks]
            .map((font) => `'${font}'`)
            .join(',');
    }
}
//# sourceMappingURL=FinancialServicesCardStyle.js.map